<template>
    <div>
        <b-modal hide-footer
                 no-close-on-backdrop
                 no-close-on-esc
                 :visible="exibirMidia"
                 id="modal-xl" size="xl" centered title="Exibição de mídias">
            <template v-slot:modal-header>
                <!-- Emulate built in modal header close button action -->
                <b-button class="offset-11" size="sm" variant="outline-secondary" @click="fechar()">
                    Fechar
                </b-button>
            </template>
            <b-img-lazy
                style="width: 100%; max-height: 500px"
                v-if="exibirTipo === 'imagem' && imagem"
                v-bind="mainProps"
                :src="imagem_reproducao"
                alt="Imagem">
            </b-img-lazy>

            <div v-if="exibirTipo === 'video' && video.length > 0">
                <b-row class="d-flex justify-content-center" align="center">
                    <b-col md="3" v-for="(dados, index) in video" :key="index">
                        <b-card
                            bg-variant="light"
                            text-variant="secondary">
                            <template v-slot:header>
                                <h6 class="mb-0">{{
                                        'Vídeo - ' + (parseInt(index) + 1) + ' (' + dados.mimetype + ')'
                                    }}</h6>
                            </template>
                            <b-button @click="reproduzirVideo(dados)" variant="outline-secondary" size="sm">
                                <b-icon icon="play" font-scale="1.2"></b-icon>
                                Reproduzir
                            </b-button>
                            <b-button  @click="downloadVideo(dados, index)" class="ml-1" variant="outline-secondary" size="sm">
                                <b-icon icon="download" title="Fazer download"></b-icon>
                                Download
                            </b-button>
                            <b-badge variant="primary" v-if="reproduzir[dados.id]">Reproduzindo</b-badge>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row class="p-3" align="center">
                    <b-col md="12">
                        <b-alert show variant="warning">
                            <b-icon animation="spin-reverse-pulse" icon="exclamation-triangle-fill"></b-icon>
                            <span class="ml-3">Alguns formatos de vídeo não são suportados para reprodução no navegador!</span>
                        </b-alert>
                    </b-col>
                    <b-col md="12" v-if="video_reproducao">
                        <video
                            controls
                            style="width: 100%; max-height: 500px"
                            :src="video_reproducao"
                        ></video>
                    </b-col>
                </b-row>
            </div>

        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'MidiaComponent',
    data() {
        return {
            imagem: null,
            imagem_reproducao: null,
            video: [],
            video_escolhido: {},
            video_reproducao: null,
            exibirMidia: false,
            exibirTipo: null,
            mainProps: {
                center: true,
            },
            reproduzir: [],
        }
    },
    methods: {
        async preencher(obj) {
            if (obj.midia.length > 0) {
                await obj.midia.forEach(dados => {
                    if (dados.tipo_midia === 'video') {
                        this.video.push(dados)
                    } else {
                        this.imagem = dados
                        this.buscarImagem()
                    } 
                })
            }
        },

        exibir(status, tipo) {
            this.exibirMidia = true;
            this.exibirTipo = tipo
        },

        fechar() {
            this.exibirMidia = false;
            this.reproduzir = [];
            this.video_reproducao = null;
        },
        reproduzirVideo(obj) {
            this.video_escolhido = obj;
            this.buscarVideo();
            this.reproduzir = [];
            this.reproduzir[obj.id] = true;
        },
        downloadVideo(obj, index) {
            if (obj.id) {
                this.$api.Storage.downloadMidia({hash_arquivo: obj.hash_arquivo, prefix: obj.prefix}).then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response.data, 'Vídeo_'+(parseInt(index)+1), obj.mimetype);
                    this.video_reproducao = null;
                }).catch(() => {
                    this.video_reproducao = null;
                })
            }
            else if(obj.hash_arquivo)
            {
                this.$api.Storage.convertMidia({hash_arquivo: obj.hash_arquivo}).then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response.data, 'Vídeo_'+(parseInt(index)+1), obj.mimetype);
                    this.video_reproducao = null;
                }).catch(() => {
                    this.video_reproducao = null;
                })
            }
            else {
                this.video_reproducao = null;
            }
        },
        buscarVideo() {
            if (this.video_escolhido.id) {
                this.$api.Storage.recuperarMidia({hash_arquivo: this.video_escolhido.hash_arquivo, prefix: this.video_escolhido.prefix}).then(response => {
                    this.video_reproducao = 'data:' + this.video_escolhido.mimetype + ';base64,' + response.data.data;
                }).catch(() => {
                    this.video_reproducao = null;
                })
            } 
            else if(this.video_escolhido.hash_arquivo)
            {
                this.video_reproducao = 'data:' + this.video_escolhido.mimetype + ';base64,' + this.video_escolhido.hash_arquivo;
            }
            else {
                this.video_reproducao = null;
            }
        },
        buscarImagem() {
            if(this.imagem.id)
            {
                this.$api.Storage.recuperarMidia({hash_arquivo: this.imagem.hash_arquivo, prefix: this.imagem.prefix}).then(response => {
                    this.imagem_reproducao = 'data:' + this.imagem.mimetype + ';base64,' + response.data.data;
                }).catch(() => {
                    this.imagem_reproducao = null;
                })
            }
            else if(this.imagem.hash_arquivo)
            {
                this.imagem_reproducao = 'data:' + this.imagem.mimetype + ';base64,' + this.imagem.hash_arquivo;
            }
        }
    }
}
</script>

<style scoped>

</style>